import { useSelector } from 'react-redux'

import { selectSlicesById } from 'redux/selectors/Slices'

/**
 * Hook for the id -> slice map, for resolving slice ids to display names.
 */
export const useSlicesById = () => {
  return useSelector(selectSlicesById)
}
